import { Box, SxProps } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';

type Props = {
  imgProps: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>;
  boxStyles?: SxProps;
  overlayVisible: boolean;
  onClick: () => void;
};

export const SelectableImage = ({ imgProps, boxStyles, overlayVisible, onClick }: Props) => {
  return (
    <Box onClick={onClick} sx={{ ...boxStyles, textAlign: 'center' }}>
      <Box
        sx={{
          position: 'relative',
          display: 'inline-block',
        }}
      >
        <img
          crossOrigin="use-credentials"
          {...imgProps}
          style={{
            display: 'block',
            width: '90%',
            height: '12rem',
            borderRadius: '5px',
            objectFit: 'cover',
          }}
        />

        {/* Conditional Overlay */}
        {overlayVisible && (
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '90%',
              height: '100%',
              borderRadius: '5px',
              background: 'hsla(167, 68%, 54%, 0.5)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'pointer',
              zIndex: 1,
            }}
          >
            <DoneIcon color="secondary" />
          </Box>
        )}
      </Box>
    </Box>
  );
};
